'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _debounce2 = require('lodash/debounce');

var _debounce3 = _interopRequireDefault(_debounce2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactRouter = require('react-router');

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _constants = require('../../../constants');

var _commonFormsy = require('../../common-formsy');

var _SmartBool = require('../../../utils/SmartBool');

var _SmartBool2 = _interopRequireDefault(_SmartBool);

var _utils = require('../../../utils');

var _GroupedSearchResultsMenu = require('./results/GroupedSearchResultsMenu');

var _GroupedSearchResultsMenu2 = _interopRequireDefault(_GroupedSearchResultsMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var DEBOUNCE_DELAY = _constants.AppConstants.DEBOUNCE_DELAY,
    DEFAULT_TRUNCATION_LENGTH = _constants.AppConstants.DEFAULT_TRUNCATION_LENGTH,
    USER_FLOW = _constants.AppConstants.USER_FLOW;
var truncate = _utils.FormattingUtils.truncate;
var SearchBar = (_dec = (0, _mobxReact.inject)('Clients', 'SessionStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(SearchBar, _Component);

  function SearchBar(props) {
    _classCallCheck(this, SearchBar);

    var _this = _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props));

    _initDefineProp(_this, 'isLoadingSearchResults', _descriptor, _this);

    _initDefineProp(_this, 'value', _descriptor2, _this);

    _initDefineProp(_this, 'searchResults', _descriptor3, _this);

    _initDefineProp(_this, 'lastRequestTimestamp', _descriptor4, _this);

    _this.debouncedOnSearch = (0, _debounce3.default)(_this.onSearchInputChange, DEBOUNCE_DELAY);
    return _this;
  }

  _createClass(SearchBar, [{
    key: 'onSearchResultSelect',
    value: function onSearchResultSelect(result) {
      var SessionStore = this.props.SessionStore;


      if (!result) {
        return;
      }

      if ((0, _isEmpty3.default)(result._search_report)) {
        // istanbul ignore next
        throw new Error('Search report not available');
      }
      SessionStore.trackEvent('SEARCH_RESULT_SELECTED', result._search_report);
      _reactRouter.browserHistory.push(Object.assign(result.path, { state: USER_FLOW.FROM_SEARCH_BAR }));
    }
  }, {
    key: 'onSearchInputChange',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
        var isMightyFreeUser, requestTimestamp, signal, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isMightyFreeUser = this.props.SessionStore.isMightyFreeUser;

                if (!(value && value.trim() && value !== this.value)) {
                  _context.next = 24;
                  break;
                }

                this.value = truncate(value, DEFAULT_TRUNCATION_LENGTH);
                requestTimestamp = new Date().getTime();

                // Check if there's an ongoing request and cancel it

                if (this.abortController) {
                  this.abortController.abort();
                  this.isLoadingSearchResults.setFalse();
                }

                // Create a new AbortController for the current request
                this.abortController = new AbortController();
                signal = this.abortController.signal;


                this.isLoadingSearchResults.setTrue();

                _context.prev = 8;

                this.lastRequestTimestamp = requestTimestamp;
                _context.next = 12;
                return this.client.list({ params: _defineProperty({}, this.searchQueryParam, value), signal: signal });

              case 12:
                response = _context.sent;


                // only update the results if the response timestamp matches the most recent request
                if (this.lastRequestTimestamp === requestTimestamp) {
                  this.searchResults = isMightyFreeUser ? this.searchResults.results : response;
                }
                _context.next = 21;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](8);

                if (!(_context.t0.name === 'AbortError')) {
                  _context.next = 21;
                  break;
                }

                // eslint-disable-next-line no-console
                console.log('Request canceled.');
                return _context.abrupt('return');

              case 21:
                _context.prev = 21;

                this.isLoadingSearchResults.setFalse();
                return _context.finish(21);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 16, 21, 24]]);
      }));

      function onSearchInputChange(_x) {
        return _ref.apply(this, arguments);
      }

      return onSearchInputChange;
    }()
  }, {
    key: 'renderMenu',
    value: function renderMenu(results, props) {
      if (!this.value) {
        return _react2.default.createElement('div', null);
      }
      return _react2.default.createElement(_GroupedSearchResultsMenu2.default, {
        isLoading: this.isLoadingSearchResults.isTrue,
        results: results,
        searchValue: this.value
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var options = this.isLoadingSearchResults.isTrue ? [] : (0, _mobx.toJS)(this.searchResults);

      return _react2.default.createElement(
        _commonFormsy.Form,
        { className: 'app-searchbar' },
        _react2.default.createElement(_commonFormsy.Typeahead, {
          className: 'fs-mask',
          fuzzySearch: true,
          name: 'search-bar',
          onChange: this.onSearchResultSelect,
          onInputChange: this.debouncedOnSearch,
          options: options,
          placeholder: 'Search...',
          renderMenu: this.renderMenu,
          search: true
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'client',
    get: function get() {
      var _props = this.props,
          Clients = _props.Clients,
          SessionStore = _props.SessionStore;


      if (SessionStore.isMightyFreeUser) {
        return Clients.caseSearch;
      }

      return Clients.search;
    }
  }, {
    key: 'searchQueryParam',
    get: function get() {
      var isMightyFreeUser = this.props.SessionStore.isMightyFreeUser;


      return isMightyFreeUser ? 'search' : 'q';
    }
  }]);

  return SearchBar;
}(_react.Component), _class3.propTypes = {
  Clients: _propTypes2.default.object.isRequired,
  SessionStore: _propTypes2.default.object.isRequired
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isLoadingSearchResults', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return new _SmartBool2.default(false);
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'value', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'searchResults', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'lastRequestTimestamp', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'onSearchInputChange', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'onSearchInputChange'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = SearchBar;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DEBOUNCE_DELAY, 'DEBOUNCE_DELAY', '/app/src/components/layout/search/SearchBar.js');
  reactHotLoader.register(DEFAULT_TRUNCATION_LENGTH, 'DEFAULT_TRUNCATION_LENGTH', '/app/src/components/layout/search/SearchBar.js');
  reactHotLoader.register(USER_FLOW, 'USER_FLOW', '/app/src/components/layout/search/SearchBar.js');
  reactHotLoader.register(truncate, 'truncate', '/app/src/components/layout/search/SearchBar.js');
  reactHotLoader.register(SearchBar, 'SearchBar', '/app/src/components/layout/search/SearchBar.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/layout/search/SearchBar.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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